import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { type VideoSources, videoSources } from '~/scopes/campaign/data/videos'

/**
 * Resolves a subject's asset name to the sources for the active locale. The data modules
 * have no Vue context, so the locale can only be read here — and every video in the
 * campaign goes through this one call.
 */
export function useVideoSources() {
  const route = useRoute()

  // Reactive off the route param rather than `useI18nLocale()` — that reads a
  // module-level ref once, and these components stay mounted across a locale switch
  // (same reasoning as `useCampaignSeo`).
  const locale = computed(() => {
    const param = route.params.locale

    return Array.isArray(param) ? param[0] : param
  })

  function sourcesFor(name: string): VideoSources {
    return videoSources(name, locale.value)
  }

  return { sourcesFor }
}
